import { createContext } from 'react';

const OwnerEntityContext = createContext({});

export default OwnerEntityContext;
